"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GATracker = void 0;
var _debug = _interopRequireDefault(require("debug"));
var _base = require("./base");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var debug = (0, _debug.default)('rentspree-tracker:ga');

/**
 * The class for Google analytic tracker
 * @param {String} options.trackingId the tracking ID for Google Analytics account
 * @extends BaseTracker
 */
var GATracker = exports.GATracker = /*#__PURE__*/function (_BaseTracker) {
  _inherits(GATracker, _BaseTracker);
  function GATracker(options) {
    var _this;
    _classCallCheck(this, GATracker);
    _this = _callSuper(this, GATracker, [options]);
    debug('initialize GATracker with trackingID:%s', options.trackingId);
    _this.trackingId = options.trackingId;
    return _this;
  }

  /**
   * Static method for getting the tracker from window
   * @returns {Function | Proxy} the gtag function, if the function is not existed in window.gtag,
   * this method will return Proxy to avoid error
   * @static
   */
  _createClass(GATracker, [{
    key: "trackPageView",
    value:
    /**
     * Track the page view by calling
     * `gtag("config", trackingId, {page_locationi: url, page_path: path})`
     * @param {String} url the url to track, this will be passed to `page_location` key
     * @param {String} path the path, this will be passed to `page_path` key
     * @param {Object} properties the additional properties
     */
    function trackPageView(url, path, _ref) {
      var ipAddress = _ref.ipAddress;
      var obj = {
        url: url,
        path: path
      };
      debug('track pageview for object %o', obj);
      GATracker.getTracker()('config', this.trackingId, {
        page_location: url,
        page_path: path,
        ipAddress: ipAddress
      });
    }

    /**
     * Identify the user by calling `gtag("config", ...userObject)`
     * the `userObject` is a return from `options.mapUserProfile(profile)`
     * @param {Object} profile the profile object
     */
  }, {
    key: "identifyUser",
    value: function identifyUser(profile) {
      debug('identify user %o', profile);

      // For UserID Tracking view
      var mappedProfile = this.mapUserProfile(profile);
      debug("gtag('set', %o)", mappedProfile);
      GATracker.getTracker()('set', mappedProfile);
      GATracker.getTracker()('event', 'Get Profile', {
        event_category: 'Technical'
      });
    }

    /**
     * track the event by calling `gtag("event", eventName, properties)`
     * @param {String} eventName the eventName
     * @param {Object} properties the properties to be passed to gtag
     */
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "trackEvent",
    value: function trackEvent(eventName) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      debug('track event for name:%s, properties:%o', eventName, properties);
      GATracker.getTracker()('event', eventName, properties);
    }
  }], [{
    key: "getTracker",
    value: function getTracker() {
      if (window.gtag) {
        return window.gtag;
      }
      debug('return proxy object for now');
      return new Proxy({}, {
        get: function get() {
          return function () {};
        }
      });
    }
  }]);
  return GATracker;
}(_base.BaseTracker);